module.exports = __webpack_public_path__ + "static/assets/05e05756b592740a3670417b4df19ca9.svg";